<template>
  <div class="modal modal-filter-details modal-talent-list fade" id="talent-nofications-modal" role="dialog" aria-labelledby="talent-nofications-modal-label" aria-hidden="true">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="talent-nofications-modal-label">Send {{ $starLabel | sentenceCase }} Notifications</h4>
      </div>
      <div class="modal-body">
        <form class="form-horizontal" @submit.prevent>
          <talent-filtering v-if="visible" :existing-talent="existingTalent" :booking="booking">
            <div slot="talent-list">
              <booking-talent-notifications-list-item
                v-for="talent in talentWithoutExisting"
                :key="talent.id"
                :talent-is-already-rejected="talentIsAlreadyRejected(talent)"
                :handle-add-talent-callback="handleAddTalentCallback"
                :handle-reject-talent-callback="handleRejectTalentCallback"
                :handle-remove-rejected-talent-callback="handleRemoveRejectedTalentCallback"
                :handle-remove-talent-callback="handleRemoveTalentCallback"
                :talent="talent"/>
            </div>
          </talent-filtering>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-lg btn-danger pull-left" @click="handleResetFilters" data-dismiss="modal" ><i class="fa fa-close"></i> Cancel</button>
        <ladda-button
          :click="handleSendTalentNotificationsCallback"
          type="button"
          class="btn btn-lg btn-primary">
          <i class="fa fa-check"></i> Save
        </ladda-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import { filter, find, findIndex, map } from 'lodash'
import LazyLoading from 'codium-lazy-loading'
import BookingTalentNotificationsListItem from './BookingTalentNotificationsListItem'
import $ from 'jquery'
import TalentFiltering from '../misc/TalentFiltering'

export default {
  data () {
    return {
      talentToReject: [],
      searching: false,
      search: {
        name: null
      },
      visible: false
    }
  },

  props: {
    booking: {
      required: true,
      type: Object
    },
    sendTalentNotificationsCallback: {
      required: true,
      type: Function
    },
    recommendations: {
      required: true,
      type: Array
    }
  },

  components: {
    TalentFiltering,
    LazyLoading,
    BookingTalentNotificationsListItem
  },

  computed: {
    ...mapState('filtering', ['stars', 'selectedStars']),

    /**
     * Filter out the existing talent against the booking from the search results.
     *
     * @return array
     */
    talentWithoutExisting () {
      return filter(this.stars, (talent) => {
        return find(this.existingTalent, (existing) => existing.id === talent.id) === undefined
      })
    },

    existingTalent () {
      return this.booking.talent_notified.concat(this.booking.talent)
    }
  },

  mounted () {
    $(this.$el).on('hidden.bs.modal', () => {
      this.talentToReject = []
      this.search.name = null
      this.visible = false
    })

    $(this.$el).on('show.bs.modal', () => {
      this.talentToReject = this.booking.talent_rejected
      this.visible = true
    })
  },

  methods: {
    ...mapActions('filtering', ['addSelectedStars', 'removeSelectedStar', 'clearAllFilters', 'setSelectedStars']),

    isRecommended (talent) {
      return find(this.recommendations, (recommended) => recommended.id === talent.id) !== undefined
    },

    /**
     * Handle adding talent to the array of talent to reject.
     *
     *  @return void
     */
    handleRejectTalentCallback (talent) {
      this.talentToReject.push(talent)
    },

    /**
     * Determine if a talent already exists within the talent to reject array.
     *
     * @return bool
     */
    talentIsAlreadyRejected (talent) {
      return find(this.talentToReject, rejected => rejected.id === talent.id) !== undefined
    },

    /**
     * Handle removing talent from the array of talent to reject.
     *
     * @return void
     */
    handleRemoveRejectedTalentCallback (talent) {
      this.talentToReject.splice(findIndex(this.talentToReject, existing => existing.id === talent.id), 1)
    },

    /**
     * Handle sending the talent notifications.
     *
     * @return Promise
     */
    handleSendTalentNotificationsCallback () {
      if (this.selectedStars.length === 0 && this.talentToReject === 0) {
        return Promise.resolve()
      } else {
        let talentAdded = map(this.selectedStars, talent => talent.id)
        let talentRejected = map(this.talentToReject, talent => talent.id)

        // eslint-disable-next-line no-sequences
        return this.sendTalentNotificationsCallback({added: talentAdded, rejected: talentRejected}).then(() => {
          this.handleResetFilters()
        })
      }
    },

    /**
     * Handle adding talent to the array of talent to notify.
     *
     * @return void
     */
    handleAddTalentCallback (talent) {
      this.addSelectedStars(talent)
    },

    /**
     * Handle removing talent from the array of talent to notify.
     *
     * @return void
     */
    handleRemoveTalentCallback (talent) {
      this.removeSelectedStar(talent.id)
    },

    handleResetFilters () {
      this.setSelectedStars([])
      this.clearAllFilters()
    }
  }
}
</script>
